import { render } from "./NotifyToastMessage.vue?vue&type=template&id=b8878dd6"
import script from "./NotifyToastMessage.vue?vue&type=script&lang=js"
export * from "./NotifyToastMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__